import { useEffect, useState } from 'react';
import axios from 'axios';
import { Card, CardContent } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Skeleton } from '@/components/ui/skeleton';
import { Newspaper, Calendar } from 'lucide-react';
import { Link } from 'react-router-dom';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function News() {
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API}/news`)
      .then(r => setArticles(r.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  return (
    <div>
      <section className="hero-wash py-14 sm:py-20">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#1F2A37] mb-4" style={{fontFamily:'Space Grotesk'}}>News</h1>
          <p className="text-lg text-muted-foreground max-w-3xl">Novit\u00e0 e approfondimenti dal mondo della salute</p>
        </div>
      </section>

      <section className="py-14 sm:py-20">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          {loading ? (
            <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">{[1,2,3].map(i => <Skeleton key={i} className="h-64 rounded-xl" />)}</div>
          ) : articles.length === 0 ? (
            <div className="text-center py-16">
              <Newspaper size={48} className="mx-auto text-muted-foreground mb-4" />
              <p className="text-lg font-medium text-[#1F2A37] mb-2" style={{fontFamily:'Space Grotesk'}}>Nessuna news pubblicata</p>
              <p className="text-muted-foreground">Torna presto per le ultime novit\u00e0</p>
            </div>
          ) : (
            <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
              {articles.map(a => (
                <Link to={`/news/${a.id}`} key={a.id} className="block">
                <Card className="overflow-hidden hover:shadow-[var(--shadow-md)] transition-shadow duration-200 flex flex-col cursor-pointer h-full">
                  {a.immagine_url && <div className="aspect-video overflow-hidden bg-[hsl(var(--muted))]"><img src={a.immagine_url} alt={a.titolo} className="w-full h-full object-cover" /></div>}
                  <CardContent className="p-5 flex-1 flex flex-col">
                    <div className="flex items-center gap-2 mb-2">
                      {a.topic_nome && <Badge className="bg-[hsl(var(--accent))] text-[hsl(var(--accent-foreground))]">{a.topic_nome}</Badge>}
                      {a.generated_by_ai && <Badge variant="secondary" className="text-[10px]">AI</Badge>}
                    </div>
                    <h3 className="text-lg font-bold text-[#1F2A37] mb-2" style={{fontFamily:'Space Grotesk'}}>{a.titolo}</h3>
                    {a.sommario && <p className="text-sm text-muted-foreground mb-3 leading-relaxed">{a.sommario}</p>}
                    <div className="mt-auto pt-3 border-t flex items-center gap-2 text-xs text-muted-foreground">
                      <Calendar size={12} />
                      {a.published_at ? new Date(a.published_at).toLocaleDateString('it-IT', {day:'numeric', month:'long', year:'numeric'}) : ''}
                    </div>
                  </CardContent>
                </Card>
                </Link>
              ))}
            </div>
          )}
        </div>
      </section>
    </div>
  );
}
